import {
  ZalamoInlineHelpClientActions,
  ZalamoInlineHelpClientActionTypes,
} from './zalamo-inline-help-client.actions';

export const zalamoInlineHelpClientFeatureKey = 'zalamoInlineHelpClient';

export interface State {
  isEditor: boolean;
}

export const initialState: State = {
  isEditor: true,
};

export function reducer(
  state = initialState,
  action: ZalamoInlineHelpClientActions
): State {
  switch (action.type) {
    case ZalamoInlineHelpClientActionTypes.LoadZalamoInlineHelpClients:
      return state;

    default:
      return state;
  }
}
